module.exports = __webpack_public_path__ + "img/title-bg.192ba793.png";